export const styles = theme => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
  },
  gridLine: {
    marginBottom: '3%',
    display: 'flex',
    justifyContent: 'center',
    [theme.breakpoints.down('lg')]: {
      display: 'block',
    },
  },
  map: {
    position: 'relative',
    zIndex: '1',
  },
  card: {
    position: 'absolute',
    backgroundColor: 'white',
    bottom: '350px',
    right: '70px',
    zIndex: '200',
    height: 'auto',
    width: '140px',
  },
  cardContent: {
    padding: '20px',
    paddingTop: '5px',
  },
  container: {
    position: 'relative',
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    color: '#537ccd',
    fontWeight: theme.typography.fontWeightRegular,
    margin: 'auto',
    padding: '0 !important',

  },
  paperMap: {
    padding: '16px',
    marginTop: theme.spacing(3),
    width: '100%',
    height: 'auto',
    [theme.breakpoints.down('lg')]: {
      width: '100%',
    },
  },
  input: {
    display: 'inline-block',
    width: '35%',
    textAlign: 'left',
    [theme.breakpoints.down('lg')]: {
      width: '50%',
    },
  },
  inputSelect: {
    width: '60%',
    [theme.breakpoints.down('lg')]: {
      width: '100%',
    },
  },
  lineGraphics: {
    width: '950px',
    margin: '10px',
    [theme.breakpoints.down('lg')]: {
      margin: '10px auto',
    },
  },
  barGraphics: {
    width: '600px',
    // margin: '10px',
    [theme.breakpoints.down('lg')]: {
      margin: '0px auto',

    },
  },
  graphics: {
    display: 'flex',
    margin: 'auto',
    [theme.breakpoints.down('lg')]: {
      display: 'block',
      width: 'auto',
    },
  },
  graphicsBar: {
    display: 'flex',
    margin: 'auto',
    [theme.breakpoints.down('lg')]: {
      display: 'block',
      width: 'auto',
    },
  },

  sliderText: {
    display: 'inline-block',
    width: '250px',
    textAlign: 'left',
  },
  paperRank: {
    padding: '16px',
    marginTop: theme.spacing(3),
    width: '35%',
    height: 'auto',
    margin: '10px',
    [theme.breakpoints.down('lg')]: {
      width: '450px',
      minHeight: '300px',
      margin: '10px auto',
    },
  },
  paperGraphics: {
    margin: '10px',
    [theme.breakpoints.down('md')]: {
      margin: '10px auto',
    },
  },

});